import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { Modal } from "@/components/common/Modal";
import { Button } from "@/components/common/Button";
import { templatesService } from "@/api/services/templates.service";
import { TemplateCategory } from "@/types/template.types";
import styles from "./TermsAndConditionsAcceptModal.module.css";
const TERMS_TEMPLATE_SUBTITLE = "Term & Conditions";
const TERMS_TEMPLATE_CATEGORY = TemplateCategory.JOB;
export const TermsAndConditionsAcceptModal = ({ isOpen, onClose, onAccept, isSubmitting = false, }) => {
    const [isLoadingUrl, setIsLoadingUrl] = useState(false);
    const [termsTemplate, setTermsTemplate] = useState(null);
    const [isLoadingTemplate, setIsLoadingTemplate] = useState(false);
    const handleClose = useCallback(() => {
        if (!isSubmitting)
            onClose();
    }, [onClose, isSubmitting]);
    const handleAccept = useCallback(async () => {
        await onAccept();
    }, [onAccept]);
    useEffect(() => {
        if (!isOpen || termsTemplate !== null)
            return;
        let cancelled = false;
        const fetchTemplate = async () => {
            setIsLoadingTemplate(true);
            try {
                const res = await templatesService.getTemplates();
                const list = Array.isArray(res.data) ? res.data : [];
                const tc = list.find((t) => t.subtitle === TERMS_TEMPLATE_SUBTITLE &&
                    t.category === TERMS_TEMPLATE_CATEGORY);
                if (!cancelled && tc) {
                    setTermsTemplate({ id: tc.id, name: tc.name });
                }
            }
            finally {
                if (!cancelled)
                    setIsLoadingTemplate(false);
            }
        };
        fetchTemplate();
        return () => {
            cancelled = true;
        };
    }, [isOpen, termsTemplate]);
    const handleDownloadClick = useCallback(async (e) => {
        e.preventDefault();
        if (!termsTemplate || isLoadingUrl)
            return;
        try {
            setIsLoadingUrl(true);
            const res = await templatesService.getDownloadUrl(termsTemplate.id);
            const url = res.data?.url;
            if (url) {
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("target", "_blank");
                link.setAttribute("rel", "noopener noreferrer");
                link.setAttribute("download", termsTemplate.name);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }
        finally {
            setIsLoadingUrl(false);
        }
    }, [termsTemplate, isLoadingUrl]);
    if (!isOpen)
        return null;
    const displayName = termsTemplate?.name ?? "Terms and Conditions";
    const canDownload = !!termsTemplate && !isLoadingUrl;
    return (_jsx(Modal, { isOpen: isOpen, onClose: handleClose, title: "Terms and Conditions", children: _jsxs("div", { className: styles.content, children: [_jsx("p", { className: styles.text, children: "By clicking Accept, you agree to the Terms and Conditions." }), isLoadingTemplate ? (_jsx("span", { className: styles.text, children: "Loading template\u2026" })) : (_jsxs("button", { type: "button", className: styles.linkButton, onClick: handleDownloadClick, disabled: !canDownload, children: ["View / Download ", displayName, isLoadingUrl && " …"] })), _jsxs("div", { className: styles.actions, children: [_jsx(Button, { type: "button", variant: "secondary", onClick: handleClose, disabled: isSubmitting, children: "Cancel" }), _jsx(Button, { type: "button", variant: "primary", onClick: handleAccept, loading: isSubmitting, disabled: isSubmitting, children: "Accept" })] })] }) }));
};
